import { useTranslation } from 'react-i18next'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { CardSelectSmall } from 'shared/ui/card-select-small'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import { CarrierSelect } from '../..'

import s from './styles.module.scss'

type Props = {
  titleKey: string
  isSameFilter?: boolean
  canDisabled?: boolean | undefined
  state: CarrierSelect[] | undefined

  onBack?: () => void
  onReset?: () => void
  onApply?: () => void
  onSelect: (value: number) => void
}

export const FilterCarrierUi = ({
  state,
  titleKey,
  canDisabled,
  isSameFilter,
  onBack,
  onReset,
  onApply,
  onSelect,
}: Props) => {
  const { t } = useTranslation()
  return (
    <div>
      <div className={s.header}>
        <HeaderResetButton
          isCanDisable={canDisabled}
          title={t(titleKey)}
          onBack={onBack}
          onReset={onReset}
        />
      </div>

      {state?.map((option, index) => (
        <div
          className={s.content}
          key={option?.id}
          onClick={() => onSelect(index)}
        >
          <CardSelectSmall
            name={option?.title}
            icon={option?.logo_url}
            isSelected={option?.selected}
          />
        </div>
      ))}

      <ButtonContinue
        onClick={onApply}
        disabled={isSameFilter}
      >
        <span className={s.text}>{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
}
